import React, { useState } from 'react';
import {
  Box,
  FormControl,
  FormLabel,
  Input,
  Button,
  VStack,
  HStack,
} from '@chakra-ui/react';

const CreditProfileForm = ({ onSubmit, onCancel, initialData = {} }) => {
  const [profileData, setProfileData] = useState({
    name: initialData.name || '',
    photographer: initialData.photographer || '',
    source: initialData.source || '',
    license: initialData.license || '',
    website: initialData.website || '',
    organization: initialData.organization || '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfileData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(profileData);
  };

  return (
    <Box as="form" onSubmit={handleSubmit}>
      <VStack spacing={4}>
        <FormControl isRequired>
          <FormLabel>Profile Name</FormLabel>
          <Input
            name="name"
            value={profileData.name}
            onChange={handleChange}
            placeholder="e.g., My Personal Photography"
          />
        </FormControl>
        <FormControl isRequired>
          <FormLabel>Photographer</FormLabel>
          <Input
            name="photographer"
            value={profileData.photographer}
            onChange={handleChange}
            placeholder="John Doe"
          />
        </FormControl>
        <FormControl>
          <FormLabel>Source</FormLabel>
          <Input
            name="source"
            value={profileData.source}
            onChange={handleChange}
            placeholder="e.g., Personal Collection, University Archive"
          />
        </FormControl>
        <FormControl>
          <FormLabel>License</FormLabel>
          <Input
            name="license"
            value={profileData.license}
            onChange={handleChange}
            placeholder="e.g., CC BY-SA 4.0"
          />
        </FormControl>
        <FormControl>
          <FormLabel>Website</FormLabel>
          <Input
            name="website"
            type="url"
            value={profileData.website}
            onChange={handleChange}
            placeholder="https://example.com"
          />
        </FormControl>
        <FormControl>
          <FormLabel>Organization</FormLabel>
          <Input
            name="organization"
            value={profileData.organization}
            onChange={handleChange}
            placeholder="e.g., Megalith Maps Contributors"
          />
        </FormControl>
        <HStack>
          <Button type="submit" colorScheme="blue">
            Save Profile
          </Button>
          <Button onClick={onCancel}>Cancel</Button>
        </HStack>
      </VStack>
    </Box>
  );
};

export default CreditProfileForm;
